import React from 'react';
import BankReconciliationPage from '../bank/bank-reconcile/pages/BankReconciliationPage.js';

const BankReconciliationPageWrapper = () => <BankReconciliationPage />;

export default BankReconciliationPageWrapper;
